import React, { PureComponent, createRef } from "react";
import { Button, Icon, Divider, message, Tooltip } from "@ss/mtd-react3";
import DownIcon from "@/assets/images/down-icon@2x.png";
import "./style.scss";
import classnames from "classnames";
import { fetchData, handleDownloadResource } from "@/utils";
import urls from "@/urls";
import { operationMaterial, getUserInfo } from "@/utils/index";
import {
    Resource_Type_Identifier,
    Resource_Type_Name
} from "@/utils/constant/teamManagement";
import { ActionType } from "@/utils/constant/index";
import qs from "qs";
import JSZip from "jszip";

import EllipsisTooltip from "@/components/tooltip/ellipsis-tooltip";

// 学诚富文本编辑器
import EditorRender from "@it/parker/es/render";
import bulletListRender from "@it/parker/es/citadel-pc/extensions/bullet-list-extension/render";
import orderedListRender from "@it/parker/es/citadel-pc/extensions/ordered-list-extension/render";
import taskListRender from "@it/parker/es/citadel-pc/extensions/task-list-extension/render";
import customTableRender from "@/components/km-editor/custom/customTableRender";
import noteRender from "@it/parker/es/citadel-pc/extensions/note-extension/render";
import collapseRender from "@it/parker/es/citadel-pc/extensions/collapse-extension/render";
import blockquoteRender from "@it/parker/es/citadel-pc/extensions/blockquote-extension/render";
import imageRender from "@it/parker/es/citadel-pc/extensions/image-extension/render";
import mentionRender from "@it/parker/es/citadel-pc/extensions/mention-extension/render";
import linkRender from "@it/parker/es/citadel-pc/extensions/link-extension/render";
import drawioRender from "@it/parker/es/citadel-pc/extensions/drawio-extension/render";
import minderRender from "@it/parker/es/citadel-pc/extensions/minder-extension/render";
import plantumlRender from "@it/parker/es/citadel-pc/extensions/plantuml-extension/render";
import statusRender from "@it/parker/es/citadel-pc/extensions/status-extension/render";
import timeRender from "@it/parker/es/citadel-pc/extensions/time-extension/render";
import latexRender from "@it/parker/es/citadel-pc/extensions/latex-inline-extension/render";
import codeRender from "@it/parker/es/citadel-pc/extensions/code-extension/render";
import attachmentRender from "@it/parker/es/citadel-pc/extensions/attachment-extension/render";
import catalogRender from "@it/parker/es/citadel-pc/extensions/catalog-extension/render";
import htmlRender from "@it/parker/es/citadel-pc/extensions/html-extension/render";
import markdownRender from "@it/parker/es/citadel-pc/extensions/markdown-extension/render";
import download from "downloadjs";

const excludeFileExtense = ["jpg", "jpeg", "png", "gif", "webp", "tiff", "pdf"];

class BrandUpload extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            detailData: {},
            imageUrlData: [],
            keywordTags: [],
            uploadFileList: [],
            activeContentValue: "",
            isAssetInfoVisible: false,
            isDownloadVisible: true,
            downloadLoading: false,
            materialDetailInfo: [],
            otherAssetsList: [],
            directoryList: [], // 添加目录列表
            selectedImageId: "", // 添加选中图片的 ID
            selectedImageUrl: "", // 添加选中图片的 URL
            selectedImageObj: "" // 添加选中图片的obj
        };
        this.view = new createRef();
        this.renderIns = new createRef();
    }
    async componentDidMount() {
        await this.fetchDirectoryList(); // 获取目录列表
        const queryMap = qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true
        });
        const { materialCode } = queryMap;
        // const { location } = this.props;
        // const { state } = location;
        if (materialCode) {
            // const { materialCode } = state;
            const data = await fetchData(
                urls.brandAggregation.assetsOuter.detailAssetsDetail,
                {
                    materialCode: materialCode
                }
            );
            // 获取第一张图片的信息
            const firstImage = data.materialImgUrl[0] || {};
            this.setState({
                detailData: {
                    ...data
                },
                // fileList: this.handleFile(data.materialFileInfo),
                imageUrlData: data.materialImgUrl,
                keywordTags: data.keyword,
                uploadFileList: data.materialFileInfo,
                imageFileList: data.materialImgUrl,
                materialDetailInfo: data.materialDetailInfo,
                activeContentValue: data.materialDetailInfo[0].fileCode,
                // 设置默认选中第一张图片
                selectedImageId: firstImage.fileCode || firstImage.uid,
                selectedImageUrl: firstImage.fileUrl,
                selectedImageObj: firstImage,
                otherAssetsList: data.otherGuidelines
            });
            this.initEditorRender();
        }
    }

    // 添加获取目录列表的方法
    async fetchDirectoryList() {
        const data = await fetchData(
            urls.brandAggregation.catalogueOuter.getCatalogue
        );
        console.log(data)
        this.setState({ directoryList: data });
    }
    // 添加获取目录名称的方法
    getDirectoryName = directoryId => {
        const { directoryList } = this.state;
        const directory = directoryList.find(
            item => item.directoryId === directoryId
        );
        return directory ? directory.directoryName : directoryId;
    };
    renderHtmlContent = content => {
        return {
            __html: content
        };
    };
    addDownloadLog = async fileUrlList => {
        const { detailData } = this.state;
        const params = {
            resourceCode: detailData.materialCode,
            resourceType: Resource_Type_Identifier.BRAND_MATERIAL,
            resourceUrlList: fileUrlList
        };

        await fetchData(urls.brandAggregation.addDownloadRecordOuter, params);
    };

    download = async fileUrl => {
        await this.addDownloadLog([fileUrl]);
        message.success({
            message: "Start downloading"
        });
        const fileNameList = (fileUrl || "").split(".");
        if (fileNameList.length > 0) {
            const extense = fileNameList[fileNameList.length - 1];
            for (const item of excludeFileExtense) {
                if (item === extense) {
                    handleDownloadResource(fileUrl);
                    return;
                }
            }
        }
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.href = fileUrl;
        a.dispatchEvent(event);
    };
    initEditorRender() {
        if (!this?.view?.current) {
            return;
        }
        this.renderIns.current = new EditorRender(this.view.current, {
            renders: [
                new bulletListRender(),
                new orderedListRender(),
                new taskListRender(),
                new customTableRender(),
                new noteRender(),
                new collapseRender(),
                new blockquoteRender(),
                new imageRender(),
                new mentionRender(),
                new linkRender(),
                new drawioRender(),
                new minderRender(),
                new plantumlRender(),
                new statusRender(),
                new timeRender(),
                new latexRender(),
                new codeRender(),
                new attachmentRender({
                    copyCallback: e => this.fileCopyCallback(e)
                }),
                new catalogRender(),
                new htmlRender(),
                new markdownRender()
            ],
            lazyload: true
        });
        const { activeContentValue, materialDetailInfo } = this.state;
        const activeItem = materialDetailInfo.find(
            item => item.fileCode === activeContentValue
        );
        this.renderIns.current.render(activeItem?.content);
    }
    fileCopyCallback = async res => {
        if (res) {
            try {
                const url = await navigator.clipboard.readText();
                await this.operationMaterial(ActionType.DOWNLOAD, url);
                message.success({
                    message: "开始下载。"
                });
                const { isCollect, material } = this.state;
                const { userMis } = await getUserInfo();
                const queryMap = qs.parse(this.props.location.search, {
                    ignoreQueryPrefix: true
                });
                const { searchId, index, isAiSearch } = queryMap;
                if (searchId) {
                    window.LXAnalytics("set", "uid", userMis);
                    const bid =
                        isAiSearch == "1"
                            ? "b_techportal_tcjb0eux_mc"
                            : "b_techportal_pne46b1f_mc";
                    window.LXAnalytics(
                        "moduleClick",
                        bid,
                        {
                            source:
                                Resource_Type_Name[
                                    Resource_Type_Identifier.MARKET_GUIDELINE
                                ],
                            event_id: searchId,
                            index,
                            userMis,
                            custom: {
                                isBuy: "0",
                                materialCode: material.materialCode
                            }
                        },
                        { cid: "c_techportal_20l0xjy8" }
                    );
                }
                if (isCollect) {
                    window.LXAnalytics("set", "uid", userMis);
                    const bid = "b_techportal_iza3jyya_mc";
                    window.LXAnalytics(
                        "moduleClick",
                        bid,
                        {
                            source: Resource_Type_Name["15"],
                            event_id: material.materialCode
                        },
                        { cid: "c_techportal_20l0xjy8" }
                    );
                }
                download(url);
            } catch (error) {
                console.error("下载失败：", error);
                message.error({ message: "下载失败！" });
            }
        } else {
            message.error({ message: "下载失败！" });
        }
    };
    // 分享链接
    operationMaterial = async activeType => {
        const { detailData } = this.state;
        await operationMaterial(
            activeType,
            Resource_Type_Identifier.MARKET_MATERIAL,
            detailData.materialCode
        );
    };
    // 添加点击处理方法
    handleContentSelect = fileCode => {
        const { materialDetailInfo } = this.state;

        this.setState(
            {
                activeContentValue: fileCode
            },
            () => {
                // 更新富文本内容
                const activeItem = materialDetailInfo.find(
                    item => item.fileCode === fileCode
                );
                if (activeItem && this.renderIns.current) {
                    this.renderIns.current.render(activeItem.content);
                }
            }
        );
    };
    // 添加图片选择处理方法
    handleImageSelect = file => {
        this.setState({
            selectedImageId: file.fileCode || file.uid,
            selectedImageUrl: file.fileUrl,
            selectedImageObj: file
        });
    };
    // 添加时间格式化函数
    formatDate = dateString => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = date
            .getDate()
            .toString()
            .padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    handleTagClick = tag => {
        this.props.history.push(
            `/search-result?keyword=${encodeURIComponent(tag)}`
        );
    };
    // 添加点击重新加载页面数据方法
    handleToAssetDetail = materialCode => {
        // 构建URL
        const url = `/assets/brand-guidelines/detail?materialCode=${materialCode}`;

        // 在新窗口打开
        window.open(url, "_blank");
        // 更新路由状态但不跳转新页面
        // this.props.history.replace({
        //     pathname: this.props.location.pathname,
        //     state: { materialCode }
        // });

        // // 重新获取数据
        // this.fetchAssetDetail(materialCode);
    };
    // 抽取获取数据的方法
    async fetchAssetDetail(materialCode) {
        const data = await fetchData(
            urls.brandAggregation.assetsOuter.detailAssetsDetail,
            { materialCode }
        );

        const firstImage = data.materialImgUrl[0] || {};
        this.setState(
            {
                detailData: { ...data },
                imageUrlData: data.materialImgUrl,
                keywordTags: data.keyword,
                uploadFileList: data.materialFileInfo,
                imageFileList: data.materialImgUrl,
                materialDetailInfo: data.materialDetailInfo,
                activeContentValue: data.materialDetailInfo[0].fileCode,
                selectedImageId: firstImage.fileCode || firstImage.uid,
                selectedImageUrl: firstImage.fileUrl,
                selectedImageObj: firstImage,
                otherAssetsList: data.otherGuidelines
            },
            () => {
                this.initEditorRender();
            }
        );
    }
    // 添加批量下载方法
    handleDownloadAll = async () => {
        const { uploadFileList } = this.state;
        const zip = new JSZip();

        try {
            this.setState({ downloadLoading: true }); // 开始加载

            const urlList = uploadFileList.map(e => e.fileUrl);
            await this.addDownloadLog(urlList);

            // 下载所有文件并添加到 zip
            const filePromises = uploadFileList.map(async file => {
                // 记录下载日志

                // 下载文件
                const response = await fetch(file.fileUrl);
                const blob = await response.blob();

                // 使用原始文件名添加到 zip
                zip.file(file.fileName, blob);
            });

            // 等待所有文件下载完成
            await Promise.all(filePromises);

            // 生成 zip 文件
            const content = await zip.generateAsync({ type: "blob" });

            // 创建下载链接
            const downloadUrl = URL.createObjectURL(content);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = `${this.state.detailData.materialName ||
                "assets"}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(downloadUrl);

            message.success({ message: "successfully" });
        } catch (error) {
            console.error("下载失败:", error);
            message.error({ message: "error" });
        } finally {
            this.setState({ downloadLoading: false }); // 结束加载
        }
    };
    render() {
        const {
            imageUrlData,
            detailData,
            isAssetInfoVisible,
            uploadFileList,
            isDownloadVisible,
            materialDetailInfo,
            selectedImageId,
            selectedImageUrl,
            selectedImageObj,
            keywordTags,
            otherAssetsList,
            downloadLoading
        } = this.state;

        return (
            <div className="asset-detail-container">
                <div className="detail-info-contact">
                    <div>
                        <div className="info-image-content">
                            <img
                                src={
                                    selectedImageUrl ||
                                    (imageUrlData[0] && imageUrlData[0].fileUrl)
                                }
                                alt="selected"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                }}
                            />
                            {/* <div className="img-title-info">
                                {selectedImageObj.fileName}
                            </div> */}
                        </div>

                        {imageUrlData.length > 1 && (
                            <div
                                style={{
                                    display: "flex",
                                    gap: "8px",
                                    marginRight: "23px"
                                }}
                            >
                                {imageUrlData.map(file => (
                                    <div
                                        key={
                                            file.fileCode
                                                ? file.fileCode
                                                : file.uid
                                        }
                                        className={`image-wall-item ${
                                            (file.fileCode || file.uid) ===
                                            selectedImageId
                                                ? "selected"
                                                : ""
                                        }`}
                                        onClick={() =>
                                            this.handleImageSelect(file)
                                        }
                                    >
                                        <img
                                            src={file.fileUrl}
                                            alt={file.fileName}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div
                        className="info-right-content"
                        style={{
                            height: imageUrlData.length > 1 ? "576px" : "480px"
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                            <div className="info-title">
                                {detailData?.materialName}
                            </div>
                            <Icon
                                className="info-share"
                                type="share-2"
                                onClick={() =>
                                    this.operationMaterial(ActionType.SHARE)
                                }
                            ></Icon>
                        </div>
                        <Divider />
                        {detailData?.designRequirements && (
                            <span className="info-description">
                                {detailData.designRequirements}
                            </span>
                        )}
                        <div className="info-detail-contact">
                            <div
                                className="asset-info"
                                onClick={() =>
                                    this.setState({
                                        isAssetInfoVisible: !isAssetInfoVisible
                                    })
                                }
                            >
                                <div className="asset-info-title">Asset</div>
                                <Icon
                                    type={
                                        isAssetInfoVisible
                                            ? "up-thick"
                                            : "down-thick"
                                    }
                                    className={`toggle-icon ${
                                        isAssetInfoVisible ? "rotate" : ""
                                    }`}
                                />
                            </div>
                            {isAssetInfoVisible && (
                                <div className="asset-info-content">
                                    <div className="info-item">
                                        <span className="label">ID</span>
                                        <span className="value">
                                            {detailData?.materialId}
                                        </span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Type</span>
                                        <span className="value">
                                            {this.getDirectoryName(
                                                detailData?.directoryId
                                            )}{" "}
                                        </span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Updated</span>
                                        <span className="value">
                                            {this.formatDate(
                                                detailData?.updateTime
                                            )}
                                        </span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Created</span>
                                        <span className="value">
                                            {this.formatDate(
                                                detailData?.createTime
                                            )}
                                        </span>
                                    </div>
                                </div>
                            )}
                            {uploadFileList.length > 0 && (
                                <>
                                    <div
                                        className="asset-info"
                                        style={{
                                            marginTop: "20px"
                                        }}
                                        onClick={() =>
                                            this.setState({
                                                isDownloadVisible: !isDownloadVisible
                                            })
                                        }
                                    >
                                        <div className="asset-info-title">
                                            Download
                                        </div>
                                        <Icon
                                            type={
                                                isDownloadVisible
                                                    ? "up-thick"
                                                    : "down-thick"
                                            }
                                            className={`toggle-icon ${
                                                isDownloadVisible
                                                    ? "rotate"
                                                    : ""
                                            }`}
                                        />
                                    </div>
                                    {isDownloadVisible && (
                                        <div className="asset-download-content">
                                            {uploadFileList.map(file => (
                                                <div
                                                    key={file.fileCode}
                                                    className="asset-file-item"
                                                >
                                                    <div className="asset-file-info">
                                                        <img
                                                            src={
                                                                file.filePreviewUrl
                                                            }
                                                            loading="lazy"
                                                        />
                                                        <div className="file-details">
                                                            <EllipsisTooltip
                                                                content={
                                                                    file.fileName
                                                                }
                                                                className="file-name"
                                                                style={{
                                                                    fontSize: 14,
                                                                    fontWeight: 400,
                                                                    margin: 0,
                                                                    fontFamily:
                                                                        "HT Heliopolis",
                                                                    color:
                                                                        "#111925"
                                                                }}
                                                                compareWidth={
                                                                    200
                                                                }
                                                            >
                                                                {file.fileName}
                                                            </EllipsisTooltip>
                                                            <div className="file-size">
                                                                {
                                                                    file.fileSizeSpc
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <img
                                                        className="asset-download-icon"
                                                        src={DownIcon}
                                                        alt=""
                                                        onClick={() =>
                                                            this.download(
                                                                file.fileUrl
                                                            )
                                                        }
                                                    />
                                                </div>
                                            ))}
                                            <Button
                                                type="primary"
                                                className="asset-download-all-btn"
                                                onClick={this.handleDownloadAll}
                                                loading={downloadLoading}
                                            >
                                                <img
                                                    className="asset-download-img-icon"
                                                    src={DownIcon}
                                                    alt=""
                                                />
                                                Download all
                                            </Button>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                {/* 富文本展示 */}
                <div>
                    <div className="detail-content-section">
                        {materialDetailInfo.length > 1 ? (
                            // 多个内容时显示列表
                            <div>
                                <div className="detail-image-list">
                                    {materialDetailInfo.map(item => (
                                        <div
                                            key={item.fileCode}
                                            className={classnames(
                                                "detail-image-item",
                                                {
                                                    active:
                                                        this.state
                                                            .activeContentValue ===
                                                        item.fileCode
                                                }
                                            )}
                                            onClick={() =>
                                                this.handleContentSelect(
                                                    item.fileCode
                                                )
                                            }
                                        >
                                            {item.title}
                                        </div>
                                    ))}
                                </div>
                                <Divider
                                    style={{
                                        margin: "18px 0 16px 0"
                                    }}
                                />
                            </div>
                        ) : (
                            // 单个内容时只显示标题
                            <div className="detail-single-title">
                                {materialDetailInfo[0]?.title ||
                                    "No content available"}
                            </div>
                        )}
                    </div>

                    <div className="asset-editor-content-wrap">
                        <div id="market-guideline-view" ref={this.view} />
                    </div>
                </div>
                <Divider style={{ marginBottom: "59px" }} />
                {/* keyword标签展示 */}
                <div>
                    <div className="detail-single-title">Similar Keywords</div>
                    <div className="keyword-tags-container">
                        {keywordTags.map((tag, index) => (
                            <div
                                key={index}
                                className="asset-keyword-tag"
                                onClick={() => this.handleTagClick(tag)}
                            >
                                {tag}
                            </div>
                        ))}
                    </div>
                </div>
                {/* 其他上传展示 */}
                {otherAssetsList.length > 0 && (
                    <div>
                        <div className="detail-single-title">More Assets</div>
                        <div className="asset-detail-card-grid">
                            {otherAssetsList.slice(0, 4).map((card, index) => (
                                <div
                                    key={card.materialId}
                                    className="asset-detail-card"
                                >
                                    <div
                                        className="asset-card-img-div"
                                        onClick={() =>
                                            this.handleToAssetDetail(
                                                card.materialCode
                                            )
                                        }
                                    >
                                        <img
                                            src={(() => {
                                                try {
                                                    return card
                                                        .materialImgUrl[0]
                                                        .fileUrl;
                                                } catch (e) {
                                                    console.error(
                                                        "解析图片URL失败:",
                                                        e
                                                    );
                                                    return ""; // 或者返回一个默认图片URL
                                                }
                                            })()}
                                            alt=""
                                            className="card-img-item-assets" // 添加不同的类名以便样式控制
                                        />
                                    </div>
                                    <div className="card-info">
                                        <div className="card-info-name">
                                            {card.materialName}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default BrandUpload;
